import { render, staticRenderFns } from "./RecipesPagination.vue?vue&type=template&id=60995aee&"
import script from "./RecipesPagination.vue?vue&type=script&lang=js&"
export * from "./RecipesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports